import { getTestId } from '@airtel/air-design-system';
export var defaultProps = Object.assign({
  uploadContainer: {
    prefixTitle: 'Drag & Drop or',
    uploadCtaTitle: ' Choose file ',
    postfixTitle: 'to upload',
    description: 'only  jpg, png, gif or pdf with max size of 5 MB',
    onUploadCtaPress: {
      id: 'choose-file-press'
    }
  },
  uploadedFiles: [{
    title: 'image.jpg',
    subTitle: '3.5 MB',
    isLoading: true
  }, {
    imgUrl: 'https://placehold.co/52',
    title: 'image.jpg',
    subTitle: '3.5 MB',
    showDeleteIcon: true,
    onDeleteIconPress: {
      id: 'delete-icon-press'
    }
  }, {
    imgUrl: 'https://placehold.co/52',
    title: 'image.jpg',
    subTitle: '3.5 MB',
    state: 'error',
    actionCtaText: 'RETRY',
    hintText: 'can’t upload the file, size shouldn’t exceed above 5 MB',
    onActionCtaPress: {
      id: 'retry-press'
    }
  }],
  onUserAction: data => {
    console.log('onUserAction', data);
  }
}, getTestId('UploadFileWidgetContainer'));